import { GmItemPackaging } from '@/generated/graphql'
import { TFunction } from 'i18next'
import type React from 'react'
import StyledChip from './styled-chip'
import { GridViewRounded, SquareRounded } from '@mui/icons-material'
import { match } from 'ts-pattern'

export const PackagingTag: React.FC<{ packaging: GmItemPackaging | null; t: TFunction }> = ({
  packaging,
  t,
}) => {
  return match(packaging)
    .with(GmItemPackaging.Individual, () => (
      <StyledChip icon={<SquareRounded />} label={t('marketplace:individualBoxes')} />
    ))
    .with(GmItemPackaging.Sharing, () => (
      <StyledChip icon={<GridViewRounded />} label={t('marketplace:sharing')} />
    ))
    .with(GmItemPackaging.Both, GmItemPackaging.Unknown, null, () => <></>)
    .exhaustive()
}
